import { useState, useEffect } from "react";
import { DCEmployeeRecord } from "./DCEmployeeRecord";

type DCPreviewEmployeeRecordProps = {
    id: string;
    properties: string[];
}

export const DCPreviewEmployeeRecord = ({id, properties} : DCPreviewEmployeeRecordProps) => {

    return (
        <div 
            className="dc-preview-employee-record"
        >
            {properties && properties.length > 0 && properties.map((property, index) => {
                return (
                    <div 
                        key={index}
                    >
                        {(() => {
                            switch(property) {
                                case "address":
                                    return (
                                        <div>
                                            <DCEmployeeRecord
                                                id={id}
                                                properties={[property]}
                                                onCancel={()=>{}}
                                                onSubmit={()=>{}}
                                             />
                                        </div>
                                    )
                                default:
                                    return (
                                        <>
                                            default preview object
                                        </>
                                    )
                                }
                            }
                        )()}
                    </div>
                )
            }
            )}
        </div>
    )
}